import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _typeof from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/typeof.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.function.name.js";
import { getCurrentUser } from 'aws-amplify/auth';
import StackTrace from 'stacktrace-js';
import fetchAPI from './http/fetchAPI';
import fetchUserAttributesCached from './fetchUserAttributesCached';
var extractExperimentId = function extractExperimentId(url) {
  var match = url.match(/experiments\/([^/]+)/i);
  return match ? match[1] : null;
};

// Truncates data arrays so that it doesn't produce large logs
var NUM_DATA_TO_SHOW = 20;
var truncateCollection = function truncateCollection(arr) {
  if (arr.length < NUM_DATA_TO_SHOW) return arr;
  var truncatedArr = arr.slice(0, NUM_DATA_TO_SHOW);
  truncatedArr.push('...');
  return truncatedArr;
};
var trimOutput = function trimOutput(key, item) {
  if (Array.isArray(item)) return truncateCollection(item);
  if (item instanceof Set) return new Set(truncateCollection(Array.from(item)));
  if (item !== null && _typeof(item) === 'object') {
    var newItem = Object.keys(item).reduce(function (newObject, childKey) {
      // eslint-disable-next-line no-param-reassign
      newObject[childKey] = trimOutput(childKey, item[childKey]);
      return newObject;
    }, {});
    return newItem;
  }
  return item;
};
var buildErrorMessage = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(errorObject, reduxState, context) {
    var user, timestamp, experimentId, url, stack, stringifiedStack, message;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          user = context.user, timestamp = context.timestamp, experimentId = context.experimentId, url = context.url;
          _context.next = 3;
          return StackTrace.fromError(errorObject);
        case 3:
          stack = _context.sent;
          stringifiedStack = stack.map(function (sf) {
            return sf.toString();
          }).join('\n');
          message = "\n    ===== ERROR STACK =====\n    Message:\n    ".concat(errorObject.message, "\n    At:\n    ").concat(stringifiedStack, "\n\n    === DETAILS ===\n    User: ").concat(user.attributes.name, " <").concat(user.attributes.email, "> ").concat(user.username, "\n    ExperimentID: ").concat(experimentId, "\n    URL: ").concat(url, "\n    Timestamp: ").concat(timestamp, "\n\n    ");
          if (reduxState) {
            message += "===== REDUX STATE =====\n    ".concat(JSON.stringify(reduxState, trimOutput, 2));
          }
          return _context.abrupt("return", message);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function buildErrorMessage(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var postError = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(errorLog, context) {
    var user, timestamp, experimentId, url, environment, message, formFields, res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          user = context.user, timestamp = context.timestamp, experimentId = context.experimentId, url = context.url, environment = context.environment;
          message = "\n  \u26A0  [".concat(environment.toUpperCase(), "] Uncaught UI Error - ExpID ").concat(experimentId, " - ").concat(timestamp, "\n  URL: ").concat(url, "\n\n  User: ").concat(user.attributes.name, " <").concat(user.attributes.email, "> ").concat(user.username, "\n  Experiment ID: ").concat(experimentId);
          formFields = {
            title: "UI Error at ".concat(new Date().toISOString()),
            initial_comment: message,
            channels: 'error-logs',
            filename: "UI-error-".concat(experimentId, "-").concat(timestamp, ".log"),
            content: errorLog
          };
          _context2.prev = 3;
          _context2.next = 6;
          return fetchAPI('/v2/sendSlackMessage', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              data: formFields,
              type: 'file'
            })
          });
        case 6:
          res = _context2.sent;
          if (res.ok) {
            _context2.next = 9;
            break;
          }
          throw new Error("Failed sending error message to Slack: ".concat(res.status), res.statusText);
        case 9:
          _context2.next = 14;
          break;
        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](3);
          console.error(_context2.t0);
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[3, 11]]);
  }));
  return function postError(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();
var postErrorToSlack = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(errorObject, reduxState) {
    var _reduxState$networkRe;
    var _yield$getCurrentUser, username, attributes, timestamp, url, experimentId, environment, context, errorLog;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return getCurrentUser();
        case 2:
          _yield$getCurrentUser = _context3.sent;
          username = _yield$getCurrentUser.username;
          _context3.next = 6;
          return fetchUserAttributesCached();
        case 6:
          attributes = _context3.sent;
          timestamp = new Date().toISOString();
          url = window.location.href;
          experimentId = extractExperimentId(url);
          environment = (reduxState === null || reduxState === void 0 || (_reduxState$networkRe = reduxState.networkResources) === null || _reduxState$networkRe === void 0 ? void 0 : _reduxState$networkRe.environment) || process.env.NODE_ENV;
          context = {
            user: {
              username: username,
              attributes: attributes
            },
            timestamp: timestamp,
            experimentId: experimentId,
            url: url,
            environment: environment
          };
          _context3.next = 14;
          return buildErrorMessage(errorObject, reduxState, context);
        case 14:
          errorLog = _context3.sent;
          _context3.next = 17;
          return postError(errorLog, context);
        case 17:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function postErrorToSlack(_x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();
export default postErrorToSlack;